import {a, Nava} from 'react-router-dom';
import { Mini1WaitLocation, Mini1WaitPhone, Mini1WaitPost, MiniBlackFaceBook, MiniBlackInstagram, MiniBlackTelegram, MiniBlackWhatsapp } from '../../assets/icones/icones';
import '../assets/css/footer.css';
import clientconfigwebapp from "../../clientconfigwebapp";
import logo_web_app from '../../assets/images/logo.png';

import {Fragment} from "react";

const Footer_Section_Bottom = () => {
    return (

        <Fragment>


            <div className={"flex gap-x-[9px] justify-center"}>

                <a href="https://t.me/bazaarano" target={"_blank"} title={"Telegram"} rel={"nofollow"}
                      className={"flex flex-row justify-center items-center hover:text-[red] m-t[10px]"}>
                    <svg width={25} height={25} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.74449 6.95012L18.0812 3.8379C22.2711 2.44124 24.5476 4.72867 23.1619 8.91863L20.0497 18.2553C17.9602 24.5348 14.5291 24.5348 12.4396 18.2553L11.5158 15.484L8.74449 14.5602C2.46505 12.4708 2.46505 9.0506 8.74449 6.95012Z"
                            stroke="#181818" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M11.7249 15.0115L15.6619 11.0635" stroke="#181818" strokeWidth="1.5"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </a>


                <a href="https://chat.whatsapp.com/GJaHo3zZ3k5AZLnDX3IaEZ" target={"_blank"} title={"whatsapp"} rel={"nofollow"}
                      className={"flex flex-row justify-center items-center hover:text-[red] m-t[10px]"}>
                    <svg width={25} height={25} viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.075 36.05C14.7 37.625 17.85 38.5 21 38.5C30.625 38.5 38.5 30.625 38.5 21C38.5 11.375 30.625 3.5 21 3.5C11.375 3.5 3.5 11.375 3.5 21C3.5 24.15 4.375 27.125 5.775 29.75L3.94044 36.806C3.74572 37.5549 4.43892 38.2317 5.18299 38.0191L12.075 36.05Z"
                            stroke="#181818" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round"
                            strokeLinejoin="round"/>
                        <path
                            d="M28.875 25.9849C28.875 26.2684 28.8119 26.5598 28.6778 26.8433C28.5438 27.1268 28.3702 27.3945 28.1415 27.6465C27.7551 28.0718 27.3292 28.3789 26.8481 28.5758C26.3749 28.7726 25.8622 28.875 25.3102 28.875C24.5057 28.875 23.646 28.686 22.739 28.3001C21.8321 27.9143 20.9251 27.3945 20.026 26.7409C19.119 26.0794 18.2593 25.347 17.4391 24.5359C16.6268 23.7169 15.8933 22.8585 15.2387 21.9608C14.592 21.063 14.0714 20.1653 13.6929 19.2754C13.3143 18.3776 13.125 17.5193 13.125 16.7003C13.125 16.1648 13.2196 15.6529 13.4089 15.1804C13.5982 14.7 13.8979 14.259 14.3159 13.8653C14.8207 13.3691 15.3727 13.125 15.9564 13.125C16.1772 13.125 16.398 13.1723 16.5952 13.2668C16.8003 13.3613 16.9817 13.503 17.1236 13.7078L18.9534 16.2829C19.0953 16.4798 19.1979 16.6609 19.2688 16.8341C19.3398 16.9995 19.3793 17.1649 19.3793 17.3145C19.3793 17.5035 19.324 17.6925 19.2136 17.8736C19.1111 18.0547 18.9613 18.2437 18.772 18.4327L18.1726 19.0549C18.0858 19.1415 18.0464 19.2439 18.0464 19.3699C18.0464 19.4329 18.0543 19.488 18.07 19.551C18.0937 19.614 18.1174 19.6612 18.1331 19.7085C18.2751 19.9684 18.5196 20.307 18.8666 20.7165C19.2215 21.126 19.6001 21.5434 20.0102 21.9608C20.4361 22.3781 20.8462 22.764 21.2642 23.1184C21.6743 23.4649 22.0135 23.7011 22.2816 23.8429C22.321 23.8586 22.3684 23.8822 22.4236 23.9059C22.4867 23.9295 22.5498 23.9374 22.6207 23.9374C22.7548 23.9374 22.8573 23.8901 22.9441 23.8035L23.5435 23.2129C23.7407 23.016 23.93 22.8664 24.1114 22.7719C24.2928 22.6616 24.4741 22.6065 24.6713 22.6065C24.8212 22.6065 24.9789 22.638 25.1524 22.7089C25.3259 22.7798 25.5073 22.8821 25.7045 23.016L28.315 24.8666C28.5201 25.0084 28.6621 25.1737 28.7488 25.3706C28.8277 25.5675 28.875 25.7644 28.875 25.9849Z"
                            stroke="#181818" strokeWidth="1.5" strokeMiterlimit={10}/>
                    </svg>

                </a>


                <a href="https://www.instagram.com/bazaarano.co?igsh=cjhzMnNrdWlydDVj" target={"_blank"}
                      title={"instagram"} rel={"nofollow"}
                      className={"flex flex-row justify-center items-center hover:text-[red] m-t[10px]"}>
                    <svg width={25} height={25} viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.75 38.5H26.25C35 38.5 38.5 35 38.5 26.25V15.75C38.5 7 35 3.5 26.25 3.5H15.75C7 3.5 3.5 7 3.5 15.75V26.25C3.5 35 7 38.5 15.75 38.5Z"
                            stroke="#181818" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path
                            d="M21 27.125C24.3827 27.125 27.125 24.3827 27.125 21C27.125 17.6173 24.3827 14.875 21 14.875C17.6173 14.875 14.875 17.6173 14.875 21C14.875 24.3827 17.6173 27.125 21 27.125Z"
                            stroke="#181818" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M30.8632 12.25H30.8834" stroke="#181818" strokeWidth={2} strokeLinecap="round"
                              strokeLinejoin="round"/>
                    </svg>

                </a>


                <a href="#" target={"_blank"} title={"youtube"} rel={"nofollow"}
                      className={"flex flex-row justify-center items-center hover:text-[red] m-t[10px]"}>
                    <svg width={30} height={30} viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M29.75 35H12.25C7 35 3.5 31.5 3.5 26.25V15.75C3.5 10.5 7 7 12.25 7H29.75C35 7 38.5 10.5 38.5 15.75V26.25C38.5 31.5 35 35 29.75 35Z"
                            stroke="#181818" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round"
                            strokeLinejoin="round"/>
                        <path
                            d="M19.9498 16.6248L24.3248 19.2498C25.8998 20.2998 25.8998 21.8748 24.3248 22.9248L19.9498 25.5498C18.1998 26.5998 16.7998 25.7248 16.7998 23.7998V18.5498C16.7998 16.2748 18.1998 15.5748 19.9498 16.6248Z"
                            stroke="#181818" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round"
                            strokeLinejoin="round"/>
                    </svg>

                </a>



            </div>

        </Fragment>


    )
}
export default Footer_Section_Bottom;